export const entities = {
  AsociereDocumentContract: 'Asociere document',
  ActAditional: 'Act adițional',
  Attachment: 'Atașament',
  ComentariuDocumentContract: 'Comentariu document',
  Contract: 'Contract',
  ContractManagementAppUser: 'Utilizator',
  GrupareContracte: 'Grupare contracte',
  IntrareFurnizor: 'Document',
  LicitatieAchizitie: 'Licitație',
  OfertaLicitatieAchizitie: 'Ofertă licitație',
  OperatiuneGarantie: 'Operațiune garanție',
  Partener: 'Partener',
  ReferintaFactura: 'Referință factură'
}
